import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Button
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import config from "../../config/config";

import "./category.scss";

function CategoryList() {
  const navigate = useNavigate();
  const [categories, setCategories] = React.useState([]);
  const [hoveredRow, setHoveredRow] = React.useState(null);
  const breadcrumbItems = [
    { title: "Categories", link: "#" },
    { title: "Category List", link: "#" },
  ];

  React.useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/categories`);
      const data = await response.json();
      console.log('Categories data:', data); // Add this to debug
      setCategories(data.data || data); // Handle both data formats
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const handleEdit = (category) => {
    navigate(`/edit-category/${category._id}`, { state: { category } });
  };

  const handleDelete = async (categoryId) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      try {
        const response = await fetch(`${config.API_BASE_URL}/categories/${categoryId}`, {
          method: 'DELETE'
        });
        
        if (response.ok) {
          // Remove the category from the state
          setCategories(categories.filter(cat => cat._id !== categoryId));
        } else {
          console.error('Failed to delete category');
        }
      } catch (error) {
        console.error('Error deleting category:', error);
      }
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Category List"
            breadcrumbItems={breadcrumbItems}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-end mb-4">
                    <Link to="/create-category">
                      <Button color="primary">
                        <i className="ri-add-line align-middle me-1"></i> Add Category
                      </Button>
                    </Link>
                  </div>
                  <div className="table-responsive">
                    <Table className="table table-centered table-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Name</th>
                          <th>Type</th>
                          <th>Image</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {categories.map((category, index) => (
                          <tr 
                            key={category._id}
                            className="category-row"
                          >
                            <td>{category._id}</td>
                            <td>{category.category_name}</td>
                            <td>{category.category_type || "Domestic"}</td>
                            <td>
                              <img
                                src={`${config.IMAGE_URL}/${category.category_image}`}
                                alt={category.category_name}
                                width="50"
                                height="50"
                                className="rounded"
                              />
                            </td>
                            <td>
                              <span className="badge bg-success">
                                Active
                              </span>
                            </td>
                            <td>
                                <button 
                                  className="category-action-buttons"
                                  onClick={() => handleEdit(category)}
                                >
                                  <i className="ri-pencil-fill"></i>
                                </button>
                                <button 
                                  className="category-action-buttons"
                                  onClick={() => handleDelete(category._id)}
                                >
                                  <i className="ri-delete-bin-fill"></i>
                                </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default CategoryList;
